<template>
  <div v-if="structure_item">
    <b-form-group label="Nome:">
      <b-form-input
        v-model="structure_item.name"
        placeholder="Nome"
        :state="validateState('name')"
      ></b-form-input>
      <b-form-invalid-feedback
        >Nome é um campo obrigatório.</b-form-invalid-feedback
      >
    </b-form-group>

    <b-form-group label="Descrição:">
      <b-form-input
        v-model="structure_item.description"
        placeholder="Descrição"
      ></b-form-input>
    </b-form-group>

    <b-form-group label="Pessoa Jurídica:">
      <LegalPerson
        v-model="structure_item.legal_person_id"
        placeholder="Pessoa Jurídica"
      />
    </b-form-group>

    <b-form-group label="Estrutura Pai:">
      <StructureSelect
        v-model="structure_item.parent_id"
        :disabled_node="disabled_node"
      />
    </b-form-group>
  </div>
</template>

<script>
import LegalPerson from "@/modules/legal_people/components/LegalPerson.vue";
import StructureSelect from "@/modules/organizational_structures/components/StructureSelect";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";

export default {
  components: { LegalPerson, StructureSelect },
  props: {},
  mixins: [validationMixin],
  data: () => ({}),
  validations: {
    structure_item: {
      name: {
        required,
        minLength: minLength(3),
      },
    },
  },
  computed: {
    ...mapState("organizational_structures", ["structure_item"]),
    disabled_node() {
      return this.structure_item.id ? this.structure_item.id : null;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.structure_item[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.structure_item.$touch();
      return !this.$v.structure_item.$anyError;
    },
  },
  created() {},
};
</script>
